<!--
 * @Descripttion:
 * @version:
 * @Author: A21
 * @Date: 2022-02-25 15:19:59
 * @LastEditors: A21
 * @LastEditTime: 2022-05-27 13:36:24
 * @FilePath: /intell-loan/src/views/pages/commonPage/BusinessLicenseSuccess.vue
-->
<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">营业执照上传成功</p>
      <Button
        :text="draw"
        :type="danger"
        :loading="isDisabled"
        :disabled="isDisabled"
        class="nextStep"
        :click='jumpCurrPage'
      />
    </div>
    <self-popup
      v-model="showContent"
      @define="define"
    ></self-popup>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { Toast } from 'vant';
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import { getIPaddressAndwechatAccessLocation } from '@/utils/index';
import { checkStatus } from './mixin';

export default {
  name: 'IdentifySuccess',
  data() {
    return {
      danger: 'danger',
      draw: '下一步',
      isDisabled: false,
      showContent: '',
    };
  },
  mixins: [checkStatus],
  components: {
    Button,
    ServerBank,
  },
  created() {
    getIPaddressAndwechatAccessLocation();
  },
  mounted() {
  },
  methods: {
    // 后端进行跳转
    jumpCurrPage() {
      this.isDisabled = true;
      const { orderId } = this.$route.query;
      this.$api.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        if (res.success && res.data) {
          window.location.href = res.data;
        } else {
          this.showContent = res.returnMessage;
        }
        this.isDisabled = false;
      }).catch((e) => {
        Toast('系统异常，请稍后再试');
        this.isDisabled = false;
      });
    },

    // 点确定跳转下一页面
    define(obj) {
      this.$store.dispatch('otherPages/jumpCurrPageServer');
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
